import { useRef } from 'react'

export const useUpdatingRef = fetcher => {
  const fetcherRef = useRef(fetcher)
  fetcherRef.current = fetcher
  return fetcherRef
}
